
import { Placement } from '@post-office/placements-frontend/rovo-nudge';
export default Placement;
